import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

export const YpOrderService = {
  async getYpCitites() {
    let response = await $axios
      .get($api("get_yp_cities"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data?.data ? response.data.data : [],
      status: response?.status,
    };
  },
  
  async getYpBranches(city_id: string) {
    console.log('getYpBranches', city_id);
    let response = await $axios
      .get($api("get_yp_branches", { city_id }), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data?.data ? response.data.data : null,
      status: response?.status,
    };
  },
  
  async getYpOrder() {
    let response = await $axios
      .get($api("package"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async PostYpOrder(payload: any) {
    try {
      const response = await $axios.post($api("post_YpOrders"), payload);
      console.log('PostYpOrder', response);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async getYptOrders(url?: string, archive?: string, page?: number) {
    let apiUrl = url;
    if (!apiUrl) {
      const params: Record<string, any> = {};
      if (archive) params.archive = archive;
      if (page && page > 1) params.page = page;
      apiUrl = $api("get_YpOrder", Object.keys(params).length ? params : undefined);
    }
    let response = await $axios
      .get(apiUrl, {
        headers: {
          "Accept-Language": "az",
          Authorization: `Bearer ${getCookie("ColibriToken")}`,
        },
      })
      .catch((err) => {
        return err.response;
      });

    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async Post_calculatedelivery(payload: any) {
    try {
      const response = await $axios.post(
        $api("post_yp_delivery"),
        payload
      );
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};